const ArrowLeftIcon = () => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M14.9001 5.40642C15.4192 5.91861 15.4192 6.75639 14.9001 7.26858L10.1213 11.9837C9.9031 12.1989 9.9031 12.5511 10.1213 12.7663L14.9001 17.4814C15.4192 17.9936 15.4192 18.8314 14.9001 19.3436C14.3907 19.8461 13.5721 19.8461 13.0628 19.3436L6.93203 13.2946C6.41932 12.7887 6.41932 11.9613 6.93204 11.4554L13.0628 5.40642C13.5721 4.90386 14.3907 4.90386 14.9001 5.40642Z"
  />
);

export default ArrowLeftIcon;
